module.exports = __webpack_public_path__ + "assets/img/ec29-gg.svg";